import styled from '@emotion/styled';
import { fraudAndComplianceColors } from 'src/assets/colors';
import { Loader } from 'src/domains/layouts/shared/loader/Loader';
import { TablePropsType, TableWrapperTemplate, TableHeaderRowTemplate, TableRowTemplate, ColumnHeaderTemplate, TableCellTemplate, SectionMessageTemplate } from 'src/components/FraudAndCompliance/FraudAndCompliancesTab/FraudAndCompliances/components/CommonTable.styles';

export const WithdrawalRequestsContainer = styled('div', { label: 'WithdrawalRequestsContainer' })`
    flex: 1 1 0%;
    height: calc(100vh - 56px);
    overflow-y: auto;
    padding: 24px;
`;

export const SectionHeader = styled('h2', { label: 'SectionHeader' })`
    font-size: 16px !important;
    color: ${fraudAndComplianceColors.withdrawalReqColors.txtColor};
    margin: 0 0 12px !important;
`;

export const SectionMessage = styled(SectionMessageTemplate, { label: 'SectionMessage' })``;

export const TableWrapper = styled(TableWrapperTemplate, { label: 'TableWrapper' })``;

export const TableHeaderRow = styled(TableHeaderRowTemplate, { label: 'TableHeaderRow' })`
`;

export const TableRow = styled(TableRowTemplate, { label: 'TableRow' }) <TablePropsType>`
`;

export const ColumnHeader = styled(ColumnHeaderTemplate, { label: 'ColumnHeader' })`
`;

export const TableCell = styled(TableCellTemplate, { label: 'TableCell' })`
    width: 16.6%;
`;

export const TableSelectCell = styled('td', { label: 'TableSelectCell' })`
    background-color: ${fraudAndComplianceColors.withdrawalReqColors.bgColor};
    padding: 4px 0 !important;
`;

export const CustomerButtonWrapper = styled('div', { label: 'CustomerButtonWrapper' })`
    width: 100%;
    border-radius: 2px;
    padding: 4px 8px;
    background: ${fraudAndComplianceColors.withdrawalReqColors.bgColor};
    cursor: pointer;
    display: inline-block;
`;

export const CustomerName = styled('span', { label: 'CustomerName' })`
    font-size: 10px;
    line-height: 1.2;
    color: ${fraudAndComplianceColors.withdrawalReqColors.txtColor};
`;

export const CustomerId = styled('span', { label: 'CustomerId' })`
    color: ${fraudAndComplianceColors.withdrawalReqColors.txtColorCustomerId};
    font-size: 10px;
    line-height: 1.1;
    display: block;
`;

export const SectionWrapper = styled('div', { label: 'SectionWrapper' })`
    position: relative;
`;

export const SmallLoader = styled(Loader, { label: 'SmallLoader' })`
    img {
        width: 30px;
    }
`;
